// src/api.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || window.location.origin;

const api = axios.create({
  baseURL: API_URL + '/api',
  withCredentials: true, // send cookies!
});

// ---- AUTH ----
export const login = (username, password) =>
  api.post('/login', { username, password });

export const logout = () => api.post('/logout');

export const checkAuth = () =>
  api.get('/check-auth').then((res) => res.data.authenticated);

// ---- DASHBOARD ----
export const fetchDashboardData = () =>
  api.get('/dashboard').then((res) => res.data);

export default api;
